import './NikeTvDateDialog.less';

import React, { useCallback, useState } from 'react';
import { dispatch } from 'nike-re-framejs';
import i18n from '@i18n';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import { pageChangeParam } from '@/routing/handlers-ng';
import imports from '@/routing/imports';
import moment from 'moment';
import PopupNg from '@/ui/PopupNg';
import LoaderMini from '@/ui/views/LoaderMini';

const Calendar = React.lazy(imports.tvNikeCalendar);

export function NikeTvDateDialog({ dateFilter, calendar }: { dateFilter: string; calendar: string[] }) {
    const [day, setDay] = useState(dateFilter);

    const handleClose = () => PopupNg.dispatcher.close('nikeTv/date-filter');

    const handleDateChange = useCallback(
        date => {
            dispatch(pageChangeParam({ date: moment(date).format('YYYY-MM-DD') }));
            setDay(day);
            handleClose();
        },
        [day]
    );

    const handleDateReset = useCallback(() => {
        dispatch(pageChangeParam({ date: undefined }));
        setDay(day);
        handleClose();
    }, [day]);

    return (
        <Docked>
            <div className="ntv-date-dialog">
                <DialogTitle>
                    <h2>{i18n('filter.title.offer.time')}</h2>
                </DialogTitle>
                <DialogBody>
                    <React.Suspense fallback={<LoaderMini className={'mt-30 mb-10'} />}>
                        <div data-atid={'niketv-calendar'}>
                            <Calendar
                                selected={day}
                                calendar={calendar}
                                onSubmit={handleDateChange}
                                onReset={handleDateReset}
                            />
                        </div>
                    </React.Suspense>
                </DialogBody>
            </div>
        </Docked>
    );
}

export default NikeTvDateDialog;
